import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AnalyticsProvider } from '@johnlewispartnership/wtr-website-analytics';
import { getAuthenticationProvider } from '@johnlewispartnership/wtr-website-authentication/dist/context';
import { AuthorizationServiceClient } from '@johnlewispartnership/wtr-website-authentication/dist/service';
import { FragmentExperimentsProvider } from '@johnlewispartnership/wtr-website-decisioner-client/express';
import { TrackedExperimentsProvider } from 'contexts/TrackedExperiments';
import { PreloadedDataProvider } from 'contexts/PreloadedData';
import { getAnalytics } from 'analytics';
import getPreloadedData from 'utils/dataPreloader/getPreloadedData';
import { CustomerOrderContextProvider } from 'contexts/CustomerOrder';
import config from 'config';
import tokenServiceClient from 'services/token';
import { cookies } from 'client/utils/cookies';
import TopBanner from 'components/TopBanner';
import fragmentConfig from 'constants/fragment-config';

const authorizationServiceClient = new AuthorizationServiceClient(
  config.services.authorizationServer.url,
);

const AuthenticationProvider = getAuthenticationProvider({
  tokenServiceClient,
  tokenServiceBasePath: config.services.tokenClient.path,
  authorizationServiceClient,
});

const renderApp = async () => {
  const rootElement = createRoot(document.getElementById('common-top-banner-root')!, {
    identifierPrefix: `${fragmentConfig.topBanner.identifier}-`,
  });

  const preloadedData = getPreloadedData('top-banner');

  rootElement.render(
    <BrowserRouter>
      <AnalyticsProvider
        // eslint-disable-next-line no-underscore-dangle
        initialEvents={window.__WTR_COMMON__['top-banner']?.analytics}
        analytics={getAnalytics()}
      >
        <FragmentExperimentsProvider
          experimentsContext={preloadedData?.experimentsContext as ExperimentsContextType}
        >
          <TrackedExperimentsProvider>
            <AuthenticationProvider
              initialState={{
                hasTokenSession:
                  cookies.get('X-Has-Token-Session', { doNotParse: true }) === 'true',
              }}
            >
              <CustomerOrderContextProvider>
                <PreloadedDataProvider preloadedData={preloadedData}>
                  <TopBanner isSupportedBrowser={preloadedData?.isSupportedBrowser as boolean} />
                </PreloadedDataProvider>
              </CustomerOrderContextProvider>
            </AuthenticationProvider>
          </TrackedExperimentsProvider>
        </FragmentExperimentsProvider>
      </AnalyticsProvider>
    </BrowserRouter>,
  );
};

renderApp();
